import {Injectable, NgZone} from "@angular/core"
import {MatSnackBar, MatSnackBarConfig} from "@angular/material/snack-bar"
import {BehaviorSubject} from "rxjs"
import {bufferTime, filter, map, skip} from "rxjs/operators"
import {ApiErrorComponent} from "src/app/_components/shared/api-error/api-error.component"
import {ISummarizedApiError} from "src/app/_interfaces/ISummarizedApiError"

@Injectable({
	providedIn: "root",
})
export class SnackbarService {
	constructor(public snackBar: MatSnackBar, private zone: NgZone) {}
	private _individualErrorSubject = new BehaviorSubject<ISummarizedApiError>(null)
	public errorBuffer$ = this._individualErrorSubject.pipe(
		skip(1),
		bufferTime(5000, 5000),
		map((errorArray) => {
			let errorsByService: {[serviceNameKey: string]: {errorMessage: string; statusCode: string}[]} = {}
			errorArray.forEach((item) => {
				const {serviceName, errorMessage, statusCode} = item
				if (errorsByService[serviceName]) {
					errorsByService[serviceName].push({errorMessage, statusCode})
				} else {
					errorsByService[serviceName] = [{errorMessage, statusCode}]
				}
			})
			return errorsByService
		}),
		filter((stuff) => {
			if (Object.keys(stuff).length > 0) {
				return true
			} else {
				return false
			}
		}),
	)

	public open(message = "Saved", action = "Dismiss", duration = 4000, panelClass = "primary-snackbar") {
		this.zone.run(() => {
			this.snackBar.open(message, action, {
				duration,
				horizontalPosition: "center",
				verticalPosition: "top",
				panelClass,
			})
		})
	}

	public openDetailedErrorSnackbar(errorsGroupedByService: {[key: string]: ISummarizedApiError[]}) {
		const config: MatSnackBarConfig = {
			panelClass: "api-error-snackbar",
			horizontalPosition: "center",
			verticalPosition: "top",
			data: errorsGroupedByService,
		}
		this.snackBar.openFromComponent<ApiErrorComponent>(ApiErrorComponent, config)
	}
	public closeErrorSnackbar() {
		this.snackBar.dismiss()
	}
	public addError(errorInfo: ISummarizedApiError) {
		this._individualErrorSubject.next(errorInfo)
	}
}
